import {Component, OnDestroy, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarMenuComponent} from './layout/sidebar-menu/sidebar-menu.component';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AuthService } from './auth/services/auth.service';
import {Toast} from 'primeng/toast';
import {WebSocketService} from './shared/services/webscoket.service';
import {NotificationHandlerService} from './shared/services/notification-handler.service';
import {environment} from '../environments/environment';
import {HttpClient} from '@angular/common/http';
import {USER_STATUS} from './shared/enums/user-status.enum';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, SidebarMenuComponent, RouterOutlet, Toast],
  styleUrls: ['./app.component.scss'],
  templateUrl: `./app.component.html`
})
export class AppComponent implements OnInit, OnDestroy {
  currentRoute: string = '';
  isLoginPage: boolean = false;

  idleTimeout: any;
  IDLE_LIMIT = 10 * 60 * 1000;
  isAway = false;

  constructor(
    private router: Router,
    public authService: AuthService,
    public webSocketService: WebSocketService,
    public notificationHandlerService: NotificationHandlerService,
    private http: HttpClient
  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.currentRoute = event.url;
      this.isLoginPage = this.currentRoute === '/login' || this.currentRoute === '/';
    });

    notificationHandlerService.init();
  }

  ngOnInit(): void {
    this.authService.isAuthenticated$.subscribe(isLoggedIn => {
      if (isLoggedIn) {
        this.webSocketService.connect(this.authService.getToken());

        const user = this.authService.getCurrentUser();
        if (user) {
          this.setOnline();
        } else {
          setTimeout(() => this.setOnline(), 500);
        }
      }
    });

    this.setupIdleTracking();

    window.addEventListener('beforeunload', () => {
      const user = this.authService.getCurrentUser();
      const userId = user?.id;

      if (userId) {
        const payload = JSON.stringify({ token: this.authService.getToken() });
        const blob = new Blob([payload], { type: "application/json" });

        const url = `${environment.apiUrl}users/${userId}/offline`;
        navigator.sendBeacon(url, blob);
      }
    });
  }

  setupIdleTracking(): void {
    const resetTimer = () => {
      if (this.isAway) {
        this.setOnline();
      }
      clearTimeout(this.idleTimeout);
      this.idleTimeout = setTimeout(() => this.setAway(), this.IDLE_LIMIT);
    };

    window.addEventListener('mousemove', resetTimer);
    window.addEventListener('keydown', resetTimer);
    window.addEventListener('click', resetTimer);
    window.addEventListener('scroll', resetTimer);

    resetTimer();
  }

  setAway(): void {
    const user = this.authService.getCurrentUser();
    if (!user?.id) return;

    this.http.post(`${environment.apiUrl}users/${user.id}/away`, {}).subscribe(() => {
      this.updateUserStatus(USER_STATUS.AWAY);
    });
    this.isAway = true;
  }

  setOnline(): void {
    const user = this.authService.getCurrentUser();
    if (!user?.id) {
      console.warn('Impossibile impostare online: Utente non trovato');
      return;
    }

    // reset readiness before attempting
    this.authService.setOnlineReady(false);
    this.http.post(`${environment.apiUrl}users/${user.id}/online`, {}).subscribe({
      next: () => {
        console.log('Online OK');
        this.updateUserStatus(USER_STATUS.ONLINE);
        this.authService.setOnlineReady(true);
      },
      error: (err) => {
        console.error('Errore durante setOnline:', err);
        // Sblocchiamo comunque la UI in caso di errore di rete
        this.authService.setOnlineReady(true);
      }
    });
    this.isAway = false;
  }

  updateUserStatus(status: USER_STATUS): void {
    const userDataString = localStorage.getItem('userData');
    if (!userDataString) return;

    try {
      const user = JSON.parse(userDataString);
      user.status = status;
      localStorage.setItem('userData', JSON.stringify(user));
    } catch {
      // this.authService.logout();
    }
  }

  ngOnDestroy(): void {
    this.webSocketService.closeConnection();
  }


}
